module.exports = __webpack_public_path__ + "img/bg_last_year.59ebf998.png";